import _sfc_main from "./AppHeader.vue2.js";
/* empty css               */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const AppHeader = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-52417838"]]);
export {
  AppHeader as default
};
//# sourceMappingURL=AppHeader.vue.js.map
